const ru = require('./ru.json');
export default ru

// export default {
//   forms: {
//     inputLoginPlaceholed: 'Логин или эл.почта',
//     passwordLabel: 'Пароль',
//     oldPasswordLabel: 'Введите предыдущий пароль',
//     newPasswordLabel: 'Новый пароль',
//     repeatPasswordPl: 'Повторите пароль',
//     restore: 'Забыли пароль?',
//     namePl: 'Имя',
//     nameLb: 'Имя',
//     groupPl: 'ООО Газпром',
//     surnamePl: 'Фамилия',
//     surnameLb: 'Фамилия',
//     email: 'E-mail',
//     emailLb: 'Email',
//     telPl: 'Телефон',
//     telLb: 'Номер телефона',
//     cityLb: 'Город',
//     cityPl: 'Москва',
//     provinceLb: 'Область',
//     provincePl: 'Москвоская',
//     countryLb: 'Страна',
//     countryPl: 'Россия',
//     postalCodeLb: 'Почтовый индекс',
//     postalCodePl: '123456',
//     lang: 'Язык интерфейса',
//     descLb: 'Описание',
//     descPl: 'Текст',
//     postalLb: 'Индекс',
//     addressLb: 'Адрес',
//     userList: 'Список пользователей',
//     fullscreen: 'Всегда в полноэкранном режиме',
//     searchAddressLb: 'Введите адрес',
//     searchAddressPl: 'Москва, Улица Ленина 9',
//     notRobot: 'Я не робот',
//     groupPhoto: 'Фотография группы',
//     userPhoto: 'Фотография пользователя',
//     uploadPhotoLabel: 'Загрузить фото',
//     notFound: 'Не найдено'
//   },
//   btns: {
//     enter: 'Войти',
//     reg: 'Зарегестрироваться',
//     add: "Добавить",
//     accept: 'Подтвердить',
//     cancel: "Отмена",
//     changePass: 'Изменить пароль',
//     create: 'Создать',
//     send: 'Отправить',
//     save: 'Сохранить',
//     success: 'Данные обновлены',
//     users: {
//       group: 'Группа пользователей',
//       user: 'Пользователь',
//       controlUsers: 'Управление пользователями',
//       controlThings: 'Управление вещами',
//       controlDashboards: 'Управление дашбордами',
//       delUser: 'Удалить',
//       copyBtn: 'Копировать ID',
//       showActivatonLink: 'Отобразить ссылку для активации',
//       repeatActivation: 'Повторить активацию',
//       enterAsUser: 'Войти как пользователь клиента',
//
//       toGroup: 'Перейти в группу',
//       editGroup: 'Редактировать',
//       editUser: 'Редактировать',
//       vidgets: 'Виджеты',
//       things: 'Вещи',
//       delGroup: 'Удалить',
//     },
//     things: {
//       new: 'Создать новую вещь',
//       import: 'Импортировать вещь'
//     }
//   },
//   labels: {
//     or: 'или',
//     coped: 'Текст скопирован'
//   },
//   errors: {
//     standard: 'Пожалуйста, заполните поле',
//     email: 'Укажите правильный e-mail',
//     passLength: 'Пароль не может быть короче',
//     passLength1: 'символов',
//     passDouble: 'Пароли не совпадают',
//     telLength: 'Телефон не может быть короче, чем',
//     telLength1: 'цифр',
//     fileSize: 'Не больше ',
//     fileSizeMB: 'Мб',
//     wrongPass: 'Неверный пароль!',
//     mailFalse: 'Email уже занят',
//     leaveConfirm: 'Изменения не были сохранены. Покинуть страницу?'
//   },
//   menu: {
//     home: 'Главная',
//     scripts: 'Сценарии',
//     users: 'Пользователи',
//     things: 'Вещи',
//     vidgets: 'Виджеты',
//     dashboards: 'Дашборды',
//     logs: 'Логи действий',
//     logout: 'Выйти',
//     switchSidebar: 'Переключение в сайдбар',
//     search: 'Поиск',
//     submenu: {
//       journal: 'Бортовой журнал',
//       profile: 'Мой профиль'
//     },
//     lang: 'Язык'
//   },
//   popups: {
//     delConfirm: {
//       title: 'Вы уверены, что хотите удалить',
//     },
//     addUser: {
//       title: 'Создать пользователя',
//       nameLb: 'Имя пользователя*',
//       mailLb: 'Эл.адрес',
//     },
//     addUserGroup: {
//       title: 'Создать группу пользователей',
//       nameLb: 'Название группы*',
//     },
//     showMoreUser: {
//       sec1: "Подробности",
//       sec2: 'История действий'
//     },
//     setUserGroup: {
//       title: 'Выберите пользователя',
//       btn: 'Прикрепить пользователя'
//     }
//   },
//   index: {
//     scripts: {
//       title: "Сценарии",
//       desc: 'Управление сценариями'
//     },
//     users: {
//       title: 'Пользователи',
//       desc: 'Управление правами пользователей'
//     },
//     things: {
//       title: 'Вещи',
//       desc: 'Управление вещами'
//     },
//     widgets: {
//       title: 'Виджеты',
//       desc: 'Управление виджетами'
//     },
//     dashboard: {
//       title: 'Дашборды',
//       desc: 'Управление дашбордами'
//     },
//     logs: {
//       title: 'Логи действий',
//       desc: 'Управление логами действий'
//     },
//     journal: {
//       title: 'Бортовой журнал',
//       desc: 'События, вещами, заметки'
//     }
//   },
//   login: {
//     title: 'Войти в систему',
//     regText: 'У вас нет аккаунта?',
//     regLink: 'Зарегистрироваться',
//     recoveryTitle: 'Восстановить пароль',
//     recoveryText: 'Письмо было отправлено на&nbsp;почту'
//   },
//   registration: {
//     title: 'Регистрация',
//     acceptText: 'Я принимаю',
//     acceptLink: 'политику конфиденциальности',
//     loginText: 'У вас уже есть аккаунт?',
//     loginLink: 'Войти'
//   },
//   profile: {
//     infoTitle: 'Основная информация',
//     dopTitle: 'Дополнительная информация',
//     passTitle: 'Изменить пароль',
//     statuses: {
//       admin: 'Администратор'
//     },
//     successPass: 'Пароль успешно изменен'
//   },
//   users: {
//     user: 'Пользователь',
//     group: 'Группа пользователей',
//     createFaceless: 'Создать обезличенного пользователя',
//     filter: {
//       title: 'Фильтр по: ',
//       all: 'Пользователи и группы',
//       user: 'Пользователи',
//       group: 'Группы',
//       empty: 'Неприкрепленные пользователи'
//     }
//   }
// }
